var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPageTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 113.41 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "waiting-list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.53,67.12A27.88,27.88,0,1,1,57.64,95,27.88,27.88,0,0,1,85.53,67.12ZM44,109.77a3,3,0,0,1,0,5.94H6.9A6.93,6.93,0,0,1,0,108.8V6.9A6.84,6.84,0,0,1,2,2V2A6.89,6.89,0,0,1,6.9,0H91.67a6.93,6.93,0,0,1,6.91,6.9V54.12a3,3,0,1,1-5.94,0V6.9a1,1,0,0,0-1-1H6.9a1,1,0,0,0-.68.27h0a1,1,0,0,0-.28.68V108.8a1,1,0,0,0,.29.68,1,1,0,0,0,.68.29ZM22.81,71.32a5.31,5.31,0,1,1-5.3,5.31,5.31,5.31,0,0,1,5.3-5.31Zm0-26a5.31,5.31,0,1,1-5.3,5.31,5.31,5.31,0,0,1,5.3-5.31ZM39,79.59a3,3,0,0,1,0-5.92H52.57a3,3,0,0,1,0,5.92Zm0-50.92a2.75,2.75,0,0,1-2.48-3,2.75,2.75,0,0,1,2.48-3H71.81a2.76,2.76,0,0,1,2.49,3,2.76,2.76,0,0,1-2.49,3ZM16.61,26.62A1.75,1.75,0,0,1,17,24.09a2,2,0,0,1,2.7-.08l1.7,1.75,5.46-4.39a1.74,1.74,0,0,1,2.48.57,2,2,0,0,1-.17,2.7l-7,5.62A1.68,1.68,0,0,1,19.93,30a1.12,1.12,0,0,1-.2-.18l-3.12-3.21Zm20.7,27a3,3,0,0,1,0-5.92H70.17a3,3,0,0,1,0,5.92ZM80.9,83.47a3.09,3.09,0,1,1,6.17,0V95.69h8.72a3.09,3.09,0,1,1,0,6.17H84a3.08,3.08,0,0,1-3.08-3.08V83.47Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageTime);
export default __webpack_public_path__ + "static/media/pageTime.09061cbd.svg";
export { ForwardRef as ReactComponent };